var _templateObject, _circle, _path, _circle2, _circle3, _circle4, _circle5, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
import styled from '@emotion/styled';
import MUISvgIcon, { svgIconClasses } from '@mui/material/SvgIcon';
import * as React from "react";
var SvgIcon = styled(MUISvgIcon)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  &.", " {\n    width: ", ";\n    height: ", ";\n    color: ", ";\n    stroke-width: 1px;\n    vector-effect: non-scaling-stroke;\n  }\n"])), svgIconClasses.root, function (_ref) {
  var size = _ref.size,
    theme = _ref.theme;
  return size && theme.size[size];
}, function (_ref2) {
  var size = _ref2.size,
    theme = _ref2.theme;
  return size && theme.size[size];
}, function (_ref3) {
  var color = _ref3.color,
    theme = _ref3.theme;
  return color && theme.color[color];
});
var SvgEmojiLoading = function SvgEmojiLoading(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, props, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 41 40"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 3,
    r: 2.5,
    fill: "#F7F5EE",
    stroke: "#2D2C2A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E2A127",
    stroke: "#2D2C2A",
    d: "M13.5 12.5h10.929a4.5 4.5 0 0 1 3.182 1.318l3.071 3.071A4.5 4.5 0 0 1 32 20.071V31a4.5 4.5 0 0 1-4.5 4.5H16.571a4.5 4.5 0 0 1-3.182-1.318l-3.071-3.071A4.5 4.5 0 0 1 9 27.929V17a4.5 4.5 0 0 1 4.5-4.5Z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 19,
    r: 3,
    fill: "#F7F5EE"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 17,
    r: 1,
    fill: "#2D2C2A"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 19,
    r: 3,
    fill: "#F7F5EE"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 17,
    r: 1,
    fill: "#2D2C2A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2D2C2A",
    d: "M21.5 24.5a2.5 2.5 0 0 1-5 0h5"
  }))));
};
export default SvgEmojiLoading;